import React from "react";

function Health() {
  return <>This is test</>;
}

export default Health;
